<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      ref="menu"
      @select="handleSelect"
      background-color="#44ce9d"
      text-color="#fff"
      v-if="visible"
      router
      active-text-color="#fff"
    >
      <el-row type="flex" justify="space-between" style="outline: none;">
        <el-col :xs="{ span: '8'}" :sm="{ span: '2'}">
          <img class="image" src="@/assets/images/Droplii_logo-white.png">
        </el-col>
        <el-col :xs="{ span: '16'}" :sm="{ span: '8'}" :lg="{ span: '4'}">
          <el-menu-item v-if="user" class="hidden-sm-and-up" index="/settings">
            <img v-if="user.PictureUri" :src="user.PictureUri" alt="" class="picture-icon">
            <font-awesome-icon v-else icon="user" class="user-icon"/>
            <span>{{` ${user.FirstName} ${user.LastName || ''}`}}</span>
            <i class="el-icon-setting white-m"></i>
          </el-menu-item>
          <el-submenu :hide-timeout="0" class="user-info hidden-xs-only" v-if="user" index="1">
            <template slot="title">
              <img v-if="user.PictureUri" :src="user.PictureUri" alt="" class="picture-icon">
              <font-awesome-icon v-else icon="user" class="user-icon"/>
              <span>{{` ${user.FirstName} ${user.LastName || ''}`}}</span>
            </template>
            <el-menu-item
              v-if="subscriptionStatus && subscriptionStatus.Status !== 0"
              index="/account"
            >Account & Billing</el-menu-item>
            <el-menu-item
              v-if="!user.IsMentor"
              @click="navToUpgrade"
              :index="$route.path"
            >Upgrade Now</el-menu-item>
            <el-menu-item index="/profile">Profile</el-menu-item>
            <div @click="$store.commit('LOGOUT')">
              <el-menu-item index="/login">Logout</el-menu-item>
            </div>
          </el-submenu>
        </el-col>
      </el-row>
    </el-menu>
  </div>
</template>



<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      activeIndex: '1',
      visible: true
    }
  },
  computed: {
    ...mapGetters(['user', 'subscriptionStatus'])
  },
  methods: {
    navToUpgrade() {
      window.location.href = 'https://droplii.com/upgrade-pricing/'
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
      // console.log(this.$refs.menu)
      // this.$refs.menu.close(key)
      // this.$refs.menu.closeMenu(1)
      // this.$refs.menu.close(key)
      // this.$refs.menu.closeMenu(1)
      // this.$refs.menu.handleSubmenuClick([key, keyPath])
      return keyPath
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/element-variables.scss';
.user-icon {
  padding: 10px;
  margin: 10px;
}
.image {
  height: 50px;
}
.color {
  background-color: $--color-primary;
  color: $--color-primary;
}
.white-m {
  color: white !important;
  margin-left: 20px;
  font-size: 20px !important;
}
</style>
<style>
.picture-icon {
  max-width: 40px;
  border-radius: 50%;
  margin-right: 15px;
  margin-left: -15px;
}
.el-submenu__title {
  margin-left: -50px !important;
}
.el-submenu__icon-arrow {
  font-size: 25px !important;
  margin-top: -13px !important;
}
</style>
